import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';// obligatoire pour faire fonctionner les popper, modal et dropdown



ReactDOM.render(<App />, document.getElementById('root'));
